import { render } from "./CampaignsDetails.vue?vue&type=template&id=357aaa2e&scoped=true"
import script from "./CampaignsDetails.vue?vue&type=script&lang=js"
export * from "./CampaignsDetails.vue?vue&type=script&lang=js"

import "./CampaignsDetails.vue?vue&type=style&index=0&id=357aaa2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357aaa2e"]])

export default __exports__